import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-reporting-modal',
    templateUrl: './reporting-modal.component.html',
    styleUrls: ['./reporting-modal.component.scss'],
    standalone: false
})
export class ReportingModalComponent implements OnInit {
    moduleName: string = 'MODULE NAME';
    contentCreator: string = 'CONTENTCREATOR';
    reportingForm: FormGroup;
    userId: number | string
    submitted: boolean = false;
    reporting: boolean = false;
    contentType: 'content' | 'city'
    contentId: number | string

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private dataService: DataService,
        private cdr: ChangeDetectorRef
    ) {
        this.reportingForm = this.formBuilder.group({
            reason: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]]
        });
    }

    ngOnInit(): void {
        // moduleName and contentCreator can be passed when the modal is opened
    }

    // Getter for easy access to form fields in template
    get f() {
        return this.reportingForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        // Stop if form is invalid
        if (this.reportingForm.invalid) {
            return;
        }

        this.reporting = true;

        this.dataService.reportContent(this.userId, {
            content_id: this.contentId,
            reason: this.reportingForm.value.reason,
            content_type: this.contentType
        }).subscribe({
            next: (res: any) => {
                this.reporting = false;
                this.cdr.detectChanges();
                this.activeModal.close({
                    action: 'submitted',
                    reason: this.reportingForm.value.reason
                });
            },
            error: (error) => {
                this.reporting = false;
                console.error('Error reporting content:', error);
            
          this.cdr.detectChanges();}
        });
    }

    closeModal() {
        this.activeModal.dismiss('cancelled');
    }
}
